import {
  Body,
  Footer,
  FormButton2,
  Head,
  InputOtp,
  OtpDesc,
  OtpTitle,
  SecretKey,
  Step,
  StepQR,
  Steps,
  Title,
} from "./style";
import { ContainerRow } from "../Container";
import React, { useEffect, useState } from "react";
import { useApp } from "../../contexts";
import QRCode from "react-qr-code";
import { FormInput } from "../Form";
import {
  getTwoFactorDisable,
  getTwoFactorStep1,
  getTwoFactorStep2,
  getTwoFactorVerify,
} from "../../services/app";
import useStateAsync from "use-state-async";
import Modal from "../Modal/Modal";
import styled from "styled-components";
import { StatusEnabled2FA } from "../../constants";

const ContentWaper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const TwoFA = (props) => {
  const { popup, setPopup, T, setUser, user, setAlert, setLoading } = useApp();
  const [otp, setOtp] = useState("");
  const [setup, setSetup, editSetup] = useStateAsync({});
  const mode = !!user?.is_twofa ? "disable" : "enable";
  const [view, setView] = useState();

  useEffect(() => {
    setView(mode === "disable" ? "otp" : "qr");
  }, [mode]);

  useEffect(() => {
    if (popup === "2fa") {
      loadData();
      document.getElementById("root").classList.add("overflow-hidden");
    }else{
      document.getElementById("root").classList.remove("overflow-hidden");
    }
  }, [popup]);

  const loadData = async () => {
    setLoading(true);
    const result = await getTwoFactorStep1();
    setLoading(false);
    setSetup(result?.data?.data || {});
  };

  const onSubmit = async () => {
    setLoading(true);
    const result = await getTwoFactorStep2(otp);
    setLoading(false);
    if (result.status === 200) {
      setAlert({
        type: "success",
        text: T("Succeeded"),
      });
      setUser({
        ...user,
        is_twofa: StatusEnabled2FA.ENABLE,
        reload: Date.now(),
      });
      onClose();
    } else {
      setAlert({
        type: "error",
        text:
          result?.data?.error?.message === "member_twofa_verify_fail"
            ? T("The authentication code is incorrect. Please try again!")
            : result?.data?.error?.message,
      });
    }
  };
  const onDisable = async () => {
    setLoading(true);
    const result = await getTwoFactorDisable(otp);
    setLoading(false);
    if (result.status === 200) {
      setAlert({
        type: "success",
        text: T("Succeeded"),
      });
      setUser({ ...user, is_twofa: StatusEnabled2FA.DISABLE });
      onClose();
    } else {
      setAlert({
        type: "error",
        text:
          result?.data?.error?.message === "member_twofa_verify_fail"
            ? T("The authentication code is incorrect. Please try again!")
            : result?.data?.error?.message,
      });
    }
  };
  const onNext = async () => {
    setView("otp");
  };

  const onClose = () => {
    setPopup("");
    setView(mode === "disable" ? "otp" : "qr");
    setOtp("");
  };

  const renderQR = () => {
    return (
      <Body>
        <Steps>
          <Step>
            <div dangerouslySetInnerHTML={{ __html: T("2FA STEP 1") }}></div>
          </Step>
          <Step>
            <div dangerouslySetInnerHTML={{ __html: T("2FA STEP 2") }}></div>
          </Step>
          <StepQR>
            {setup?.uri && <QRCode className="w-[180px] h-[180px]" value={setup?.uri || ""} />}
            
            {/* <img src={setup?.qr} /> */}
          </StepQR>
        </Steps>
        <SecretKey>
          <span>{T("Secret key:")}</span>
          <FormInput value={setup?.secret || ""} />
        </SecretKey>
      </Body>
    );
  };

  const renderOTP = () => {
    return (
      <Body style={{ alignItems: "center" }}>
        <OtpTitle>{T("2 Factor Authentication")}</OtpTitle>
        <OtpDesc>{T("Enter 6-digit code generated by your app")}</OtpDesc>
        <InputOtp
          value={otp}
          onChange={(event) => {
            setOtp(event);
          }}
        />
        {/*<Resent>{T("Resend")}</Resent>*/}
      </Body>
    );
  };
  return popup === "2fa" ? (
    <Modal onClose={onClose}>
      <Modal.ModalBg onClose={onClose} />
      <Modal.Container onClose={onClose} width="700px" style={{ background: '#F5F5F5'}}>
        <ContentWaper>
          <Head>
            <Title>
              {mode === "disable" ? T("Disable 2FA") : T("Enable 2FA")}
            </Title>
          </Head>
          {view === "qr" ? renderQR() : null}
          {view === "otp" ? renderOTP() : null}
          <Footer>
            <ContainerRow>
              {view === "qr" ? (
                <FormButton2 onClick={() => onNext()}>{T("Next")}</FormButton2>
              ) : null}
              {view === "otp" && mode === "enable" ? (
                <FormButton2 onClick={() => onSubmit()}>
                  {T("Enable 2FA")}
                </FormButton2>
              ) : null}
              {view === "otp" && mode === "disable" ? (
                <FormButton2 onClick={() => onDisable()}>
                  {T("Disable 2FA")}
                </FormButton2>
              ) : null}
            </ContainerRow>
          </Footer>
        </ContentWaper>
      </Modal.Container>
    </Modal>
  ) : null;
};
